import React from "react";
import { useTranslation } from "react-i18next";
import { ModalFooter } from "reactstrap";
import { useSnapshot } from "valtio";
import { toast } from "react-toastify";
import { mutate } from "swr";

import { deviceStore, setIsConfigurationPrinterClicked } from "../store";
import { store, setIsValidateClicked } from "./store";
import { StoreGeneral } from "./General/Hook/store";

import { store as userStore } from "@components/VerticalLayout/store";
import { resetStore as resetStoreCustomer } from "./CustomerTicket/Hook/store";
import { resetStore as resetStoreKitchenTicket } from "./KitchenTicket/Hook/store";
import { resetStore as resetStoreDivers } from "./Divers/Hook/store";
import { resetStore as resetStoreModelTicket } from "./ModeleTicket/store";

import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";
import { useFetchGlobal } from "../../../../../api/hooks";
import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";

type ModalFooterType = {
    rowData: any;
    resetStore: Function;
    setDataIsUpdated: Function;
};

export function PrinterFooter({
    rowData,
    resetStore,
    setDataIsUpdated,
}: ModalFooterType) {
    const { t } = useTranslation();
    const { fetchGlobal } = useFetchGlobal();
    const { oneShop, shopID, userID, franchiseID, operatorID } = useSnapshot(
        userStore
    );
    const { isConfigurationPrinterClicked } = useSnapshot(deviceStore);
    const {
        dataGeneral,
        dataDivers,
        dataKitchenTicket,
        dataCustomerTicket,
        dataFirstTicket,
        dataSecondTicket,
        dataThreedTicket,
        dataFourthTicket,
        dataFifthTicket,
    } = useSnapshot(store);
    const { typeLogoCustomer, typeLogoKitchen } = useSnapshot(StoreGeneral);
    const isJpgOrPng =
        typeLogoCustomer === "image/jpeg" ||
        typeLogoCustomer === "image/png" ||
        typeLogoCustomer === "image/ico" ||
        typeLogoCustomer === "image/jpg";
    const isJpgOrPngKitchen =
        typeLogoKitchen === "image/jpeg" ||
        typeLogoKitchen === "image/png" ||
        typeLogoKitchen === "image/ico" ||
        typeLogoKitchen === "image/jpg";

    async function handleValidateButtonClickEvent() {
        let apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/application/pos/printer/setting`;
        let shopId: string;
        let modelKitchenTicket = {
            model_1: dataFirstTicket,
            model_2: dataSecondTicket,
            model_3: dataThreedTicket,
            model_4: dataFourthTicket,
            model_5: dataFifthTicket,
        };
        if (oneShop) {
            shopId = shopID.toString();
        } else {
            shopId = rowData.shopId;
        }
        let savedData = {
            userId: userID,
            shopId: shopId,
            uuidUser: localStorage.getItem("uuidUser"),
            franchiseId: franchiseID,
            operatorId: operatorID,
            appName: [rowData?.applicationDesignation],
            appId: "POS",
            appId_children: rowData.appId,
            peripheralId: rowData.peripheralId,
            data: {
                customer_ticket: dataCustomerTicket,
                divers: dataDivers,
                general: dataGeneral,
                Kitchen_ticket: dataKitchenTicket,
                modelKitchenTicket: modelKitchenTicket,
            },
        };
        try {
            const data: any = await fetchGlobal(apiUrl, {
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(savedData),
                method: "POST",
            });
            mutate(apiUrl, data);
            if (data.error) {
                throw Error("Error while saving selection!");
            }
            toast.success(`${t("Registration successfully")!}`, {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
                theme: "colored",
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            setIsValidateClicked(true);
            setIsConfigurationPrinterClicked(!isConfigurationPrinterClicked);
            setDataIsUpdated(true);
        } catch (e: any) {
            toast.error(`${t("There's an error")}!`, {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
                theme: "colored",
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }
    }
    return (
        <ModalFooter>
            <CustomSecondaryColorButton
                outline
                style={{
                    height: "48px",
                }}
                rounded
                className="mr-2"
                variant="light"
                onClick={() => {
                    setIsConfigurationPrinterClicked(
                        !isConfigurationPrinterClicked
                    );
                    resetStore();
                    resetStoreCustomer();
                    resetStoreKitchenTicket();
                    resetStoreDivers();
                    resetStoreModelTicket();
                }}
            >
                <span>{t("Cancel")}</span>
            </CustomSecondaryColorButton>
            <CustomMainColorButton
                rounded
                style={{
                    height: "48px",
                }}
                variant="primary"
                onClick={() => {
                    if (
                        (isJpgOrPng && isJpgOrPngKitchen) ||
                        (typeLogoCustomer === "" && typeLogoKitchen === "") ||
                        (isJpgOrPng && typeLogoKitchen === "") ||
                        (isJpgOrPngKitchen && typeLogoCustomer === "")
                    ) {
                        handleValidateButtonClickEvent();
                    }
                }}
            >
                {t("Validate")}
            </CustomMainColorButton>
        </ModalFooter>
    );
}
